import { getListOfAccounts } from "../types/account_list_types";

const initState = {
  data: [],
  Count: 0,
  loading: false,
  error: null,
  cellLoading: null,
};

export default function accountListReducer(state = initState, action = {}) {
  switch (action.type) {
    case getListOfAccounts.GET_LIST_OF_ACCOUNTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getListOfAccounts.GET_LIST_OF_ACCOUNTS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        Count: action.payload.Count,
        error: null,
      };
    case getListOfAccounts.GET_LIST_OF_ACCOUNTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
